export default __webpack_public_path__ + "static/media/spiderman.ca991e07.png";